import type { HeroSlide } from "@/types/content";

export const heroSlides: HeroSlide[] = [
  {
    id: "slide-neon-rain",
    filmId: "neon-rain",
    kicker: "编辑精选 · 经典修复",
    headline: "霓虹夜雨",
    description:
      "持续十七天的雨、一间即将清拆的唱片行，和一段没有说完的告别。九十年代港产类型片代表作，4K 修复版资料已上线。",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20rain%20soaked%20neon%20city%20street%20at%20night%2C%20magenta%20and%20amber%20reflections%20on%20wet%20asphalt%2C%20atmospheric%20fog%2C%20empty%20road%2C%20moody%20noir%20color%20grade%2C%2035mm%20grain%2C%20no%20text&width=1920&height=1080&seq=hero-neon-rain&orientation=landscape",
  },
  {
    id: "slide-glass-mask",
    filmId: "glass-mask",
    kicker: "近期热播 · 双线叙事",
    headline: "玻璃假面",
    description:
      "配音演员替一位从不露面的作家录制有声书，却在第七章读到了自己的童年。爱情与悬疑相互咬合的一次精巧尝试。",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20interior%20still%20of%20an%20elegant%20vintage%20apartment%20with%20warm%20lamp%20light%2C%20velvet%20curtains%20and%20tall%20windows%20at%20golden%20hour%2C%20soft%20haze%2C%20analog%20film%20grain%2C%20no%20text&width=1920&height=1080&seq=hero-glass-mask&orientation=landscape",
  },
  {
    id: "slide-maze-tower",
    filmId: "maze-tower",
    kicker: "年度悬疑 · 空间叙事",
    headline: "迷楼",
    description:
      "一栋只有十一层的公寓，电梯按钮却排到了十三。近两年最会玩空间的悬疑作品，每一层都藏着不同的答案。",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20dramatic%20spiral%20staircase%20in%20deep%20violet%20shadow%20with%20a%20warm%20lamp%20glowing%20at%20the%20center%2C%20moody%20architecture%2C%20film%20grain%2C%20no%20text&width=1920&height=1080&seq=hero-maze-tower&orientation=landscape",
  },
  {
    id: "slide-alley-detective",
    filmId: "alley-detective",
    kicker: "口碑推荐 · 本格推理",
    headline: "暗巷侦探",
    description:
      "旧城区接连失窃，丢的全是不值钱的东西。退休警探沿着巷子里的灯一路查下去，最后回到了自己的旧住址。",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20narrow%20old%20town%20alley%20at%20dusk%20with%20amber%20street%20lamps%20and%20wet%20cobblestones%2C%20noir%20atmosphere%2C%20drifting%20haze%2C%20film%20grain%2C%20no%20text&width=1920&height=1080&seq=hero-alley-detective&orientation=landscape",
  },
];